<ng-container *ngIf="appTranslated">
    <div *ngIf="helpersService.config" class="d-flex flex-column justify-content-between h-100">
        <div class="fixed-top" [hidden]="!headerFixed || helpersService.headerType === 'headerInsurance' || helpersService.headerType === 'headerImg'">
            <div class="bg-white w-100">
                <div class="container">
                    <div class="row gx-0 justify-content-center">
                        <div class="col-12 col-md-8 col-lg-6">
                            <vfa-cp-header-fixed></vfa-cp-header-fixed>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="helpersService.isHome" class="bg-grey w-100">
                <div class="container">
                    <div class="row gx-0 justify-content-center">
                        <div class="col-12 col-md-8 col-lg-6">
                            <div class="pt-3">
                                <vfa-cp-dashboard-home-buttons></vfa-cp-dashboard-home-buttons>
                            </div>
                            <hr class="my-3 mx-auto w-50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid d-flex flex-column p-0">
            <div class="header-web-container">
                <div class="content  {{ helpersService.headerType === 'headerRed' ? 'red-header__background red-header__down-header' : '' }} {{ helpersService.headerType === 'headerInsurance' ? 'insurance-header__background insurance-header__down-header' : '' }} {{ helpersService.headerType === 'headerImg' ? 'img-header__background img-header__down-header' : '' }} {{ helpersService.headerType === 'headerWhite' ? 'white-header__background' : '' }}">
                    <div class="container">
                        <div class="row gx-0 justify-content-center">
                            <div *ngIf="helpersService.config" class="col-12 col-md-8 col-lg-6">
                                <vfa-cp-header></vfa-cp-header>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content h-100" [class.red-header__up-content]="helpersService.headerType === 'headerRed'" [class.img-header__up-content]="helpersService.headerType === 'headerImg'" [class.insurance-header__up-content]="helpersService.headerType === 'headerInsurance'">
                <div class="container">
                    <div class="row justify-content-center">
                        <div *ngIf="helpersService.config" class="col-12 col-md-8 col-lg-6 pt-3 pb-3">
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-4">
            <vfa-cp-footer></vfa-cp-footer>
        </div>
    </div>
</ng-container>
<ng-template #maintenanceModal let-modal>
    <div class="bg-primary rounded-top d-flex justify-content-center py-3">
        <div class="icp-maintenance-image" style="width: 216px; height: 100px;"></div>
    </div>
    <div class="pt-5 ps-3 pe-3 pb-3">
        <div class="pb-5" [innerHTML]="message"></div>
        <button class="w-100 btn btn-primary mb-3" (click)="closeModal()">{{"common-got-it" | translate}}</button>
    </div>
</ng-template>